import ContactForm from "components/ContactForm";
import { Wrapper, Section, Description, SectionHeading, Address, AddressHeading, Col } from "./style";
import TwoColumnsGrid from "components/TwoColumnsGrid";

const FormSection = ({pTop, pBottom, bgColor}: any) => (
  <Section
    className="FormSection"
    sx={{
      backgroundColor: `${bgColor}`,
      paddingTop: `calc(${pTop} * 0.52)`,
      paddingBottom: `calc(${pBottom} * 0.52)`,

      "@media (min-width: 768px)": {
        paddingTop: `calc(${pTop} * 0.8)`,
        paddingBottom: `calc(${pBottom} * 0.8)`,
      },
      "@media (min-width: 1200px)": {
        paddingTop: `calc(${pTop} * 1)`,
        paddingBottom: `calc(${pBottom} * 1)`
      }
    }}
  >
    <Wrapper>
      <TwoColumnsGrid>
        <Col>
          <SectionHeading
            variant="h2"
          >
            Get in Touch
          </SectionHeading>
          <Description
            variant="body1"
          >
            "Promoting our IR activities through 6ix Leads has been a game changer for us: precise targeting, data-driven analytics and effective campaign execution.”
          </Description>
          <Address>
            <AddressHeading
              variant="caption"
            >
              Alex Barankin
            </AddressHeading>
            President and CEO <br />SR&ED Plus Nexus
          </Address>
        </Col>
        <Col>
          <ContactForm />
        </Col>
      </TwoColumnsGrid>
    </Wrapper>
  </Section>
);

export default FormSection;